/* rastah-gwp-cart-ui v12
   ============================================================
   Cart drawer + cart page UI for the Buy-2-Get-1 free-gift
   offers. Injects a promo block into the quick-cart drawer and
   the cart page without editing those (very large) sections.

   v11: bounded self-heal; gift recognised by product id.
   v12 (CLEANUP + PERF):
     1. Discount-label sweep is now DOCUMENT-WIDE. The cart page's
        section is id="shopify-section-template--<id>__main", not
        "#shopify-section-main-cart", so neither the CSS nor the
        old sweep ever reached it -- which is why the pink
        "RASTAH Free Gift (-$0.00)" tags still showed on the two
        bundle products there. Only labels naming our own gift
        discount are hidden; every other promo label is untouched.
     2. Shared cart snapshot. This file and rastah-gwp-sync.js each
        used to hit /cart.js on every cart event -- two requests
        for the same data, several times per interaction. They now
        share a 500ms-lived snapshot via window.__rastahGwpCart.
     3. Idle-time rendering: the re-render is scheduled through
        requestIdleCallback where available, so cart chatter never
        competes with the drawer's own paint.
   ============================================================ */
(function () {
  'use strict';

  var CFG_SEL = 'script[data-rastah-gwp-config]';
  var PROP = '_rastah_gwp';
  var HOSTS = ['#shopify-section-quick-cart', '#shopify-section-main-cart'];
  var BLOCK_CLASS = 'rastah-gwp-cartblock';
  var STYLE_ID = 'rastah-gwp-cartblock-css';
  var GIFT_DISCOUNT_MATCH = 'RASTAH Free Gift';
  var MAX_HEALS = 3;
  var healCount = 0;
  var debounceTimer = null;
  var rendering = false;
  var lastHealAt = 0;

  function offers() {
    var el = document.querySelector(CFG_SEL);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '.rastah-gwp-cartblock{margin:12px;padding:14px;border:1px solid var(--gwpc-border,#e8e8e8);border-radius:10px;background:var(--gwpc-bg,#fff);color:var(--gwpc-text,#1a1a1a);font-size:13px}'
      + '#shopify-section-main-cart .rastah-gwp-cartblock{max-width:720px;margin-left:auto;margin-right:auto}'
      + '.rastah-gwp-cartblock__badge{display:inline-block;font-size:10px;letter-spacing:.08em;text-transform:uppercase;padding:3px 7px;border-radius:999px;background:var(--gwpc-btn,#1a1a1a);color:var(--gwpc-btn-text,#fff);margin-bottom:8px}'
      + '.rastah-gwp-cartblock__heading{margin:0 0 10px;font-size:14px}'
      + '.rastah-gwp-cartblock__steps{display:flex;gap:6px;margin:0 0 12px;padding:0;list-style:none;font-size:11px;opacity:.9}'
      + '.rastah-gwp-cartblock__steps li{flex:1;text-align:center;padding:5px 4px;border-radius:6px;background:rgba(255,255,255,.08);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.rastah-gwp-cartblock__steps li.is-done{background:var(--gwpc-btn,#c8842d)}'
      + '.rastah-gwp-cartblock__row{display:flex;align-items:center;gap:10px}'
      + '.rastah-gwp-cartblock__thumb{position:relative;flex:0 0 auto;width:48px;height:48px;border-radius:6px;overflow:hidden}'
      + '.rastah-gwp-cartblock__thumb img{width:100%;height:100%;object-fit:cover;display:block}'
      + '.rastah-gwp-cartblock__flag{position:absolute;left:3px;bottom:3px;font-size:8px;font-weight:700;background:var(--gwpc-btn,#1a1a1a);color:var(--gwpc-btn-text,#fff);padding:1px 4px;border-radius:3px}'
      + '.rastah-gwp-cartblock__info{min-width:0;flex:1}'
      + '.rastah-gwp-cartblock__title{display:block;color:var(--gwpc-text,#1a1a1a);text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.rastah-gwp-cartblock__price{opacity:.85}'
      + '.rastah-gwp-cartblock__was{opacity:.6;text-decoration:line-through;margin-right:5px}'
      + '.rastah-gwp-cartblock__free{color:var(--gwpc-btn,#1a1a1a);font-weight:700}'
      + '.rastah-gwp-cartblock__add{flex:0 0 auto;border:none;cursor:pointer;background:var(--gwpc-btn,#1a1a1a);color:var(--gwpc-btn-text,#fff);padding:8px 12px;border-radius:6px;font-size:11px;letter-spacing:.04em;text-transform:uppercase}'
      + '.rastah-gwp-cartblock__add[disabled]{opacity:.6;cursor:wait}'
      + '.rastah-gwp-cartblock__unlocked{display:flex;align-items:center;gap:8px;font-weight:600}'
      + '.rastah-gwp-cartblock--success{animation:rastahGwpPop .35s ease}'
      + '.rastah-gwp-cartblock,.rastah-gwp-cartblock__add,.rastah-gwp-cartblock__sel{font-family:inherit}'
      + '.rastah-gwp-cartblock__sel{flex:0 0 auto;max-width:40%;background:transparent;color:var(--gwpc-text,#1a1a1a);border:1px solid var(--gwpc-border,#ccc);border-radius:6px;padding:6px 8px;font-size:11px;margin-right:6px}'
      + '.rastah-gwp-cartblock__sel option{color:#111}'
      + '.rastah-gwp-hidden-discount{display:none !important}'
      + '@keyframes rastahGwpPop{0%{transform:scale(.97);opacity:.6}100%{transform:scale(1);opacity:1}}';
    var tag = document.createElement('style');
    tag.id = STYLE_ID;
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /* v12: one shared, short-lived cart snapshot for both GWP scripts. */
  function getCart() {
    var c = window.__rastahGwpCart;
    var now = Date.now();
    if (c && c.p && (now - c.t) < 500) return c.p;
    var p = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
    window.__rastahGwpCart = { t: now, p: p };
    return p;
  }

  function productCard(p, opts) {
    var flag = opts && opts.gift ? '<span class="rastah-gwp-cartblock__flag">GIFT</span>' : '';
    var price = opts && opts.gift
      ? '<span class="rastah-gwp-cartblock__was">' + esc(p.was) + '</span><span class="rastah-gwp-cartblock__free">FREE</span>'
      : '<span class="rastah-gwp-cartblock__price">' + esc(p.price) + '</span>';
    var btn = '';
    if (opts && opts.addable) {
      if (p.single && p.variant) {
        btn = '<button type="button" class="rastah-gwp-cartblock__add btn" data-gwp-add="' + p.variant + '">' + esc(opts.button) + '</button>';
      } else if (p.vars && p.vars.length) {
        var optsHtml = '';
        p.vars.forEach(function (v) { optsHtml += '<option value="' + v[0] + '">' + esc(v[1]) + '</option>'; });
        btn = '<select class="rastah-gwp-cartblock__sel" data-gwp-variant-select aria-label="Select option">' + optsHtml + '</select>'
          + '<button type="button" class="rastah-gwp-cartblock__add btn" data-gwp-add-rel>' + esc(opts.button) + '</button>';
      } else {
        btn = '<a class="rastah-gwp-cartblock__add btn" href="' + esc(p.url) + '">' + esc(opts.button) + '</a>';
      }
    }
    return '<div class="rastah-gwp-cartblock__row">'
      + '<a class="rastah-gwp-cartblock__thumb" href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="" loading="lazy">' + flag + '</a>'
      + '<div class="rastah-gwp-cartblock__info"><a class="rastah-gwp-cartblock__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + price + '</div>'
      + btn
      + '</div>';
  }

  function blockHTML(o, state, place) {
    var style = '--gwpc-bg:' + o.colors.bg + ';--gwpc-border:' + o.colors.border + ';--gwpc-text:' + o.colors.text + ';--gwpc-btn:' + o.colors.btn + ';--gwpc-btn-text:' + (o.colors.btnText || '#fff') + ';';
    var inner;
    if (state.qualifies) {
      var unlockedMsg;
      if (state.giftIn) {
        unlockedMsg = 'Gift unlocked \u2014 added to your cart';
      } else if (healCount < MAX_HEALS) {
        unlockedMsg = 'Gift unlocked \u2014 adding to your cart\u2026';
      } else {
        unlockedMsg = 'Gift unlocked \u2014 it will be applied at checkout';
      }
      inner = '<span class="rastah-gwp-cartblock__badge">' + esc(o.badge) + '</span>'
        + '<div class="rastah-gwp-cartblock__unlocked">\uD83C\uDF81 ' + unlockedMsg + '</div>'
        + '<div style="height:10px"></div>'
        + productCard(o.gift, { gift: true });
    } else {
      var missing = state.hasA ? o.buy_b : o.buy_a;
      var have = state.hasA ? o.buy_a : o.buy_b;
      inner = '<span class="rastah-gwp-cartblock__badge">' + esc(o.badge) + '</span>'
        + '<p class="rastah-gwp-cartblock__heading">' + esc(o.heading) + ' \u2014 you\u2019re 1 product away</p>'
        + '<ul class="rastah-gwp-cartblock__steps">'
        + '<li class="is-done">\u2713 ' + esc(have.title) + '</li>'
        + '<li>+ ' + esc(missing.title) + '</li>'
        + '<li>\uD83C\uDF81 ' + esc(o.gift.title) + '</li>'
        + '</ul>'
        + productCard(missing, { addable: true, button: o.button })
        + '<div style="height:8px"></div>'
        + productCard(o.gift, { gift: true });
    }
    return '<div class="' + BLOCK_CLASS + (state.qualifies ? ' rastah-gwp-cartblock--success' : '')
      + '" data-gwp-offer="' + esc(o.handle) + '" data-gwp-state="' + (state.qualifies ? (state.giftIn ? 'unlocked' : 'healing') : 'progress')
      + '" data-gwp-place="' + place + '" style="' + style + '">' + inner + '</div>';
  }

  function offerState(o, cart) {
    var hasA = false, hasB = false, giftIn = false;
    var giftProductId = o.gift && o.gift.id;
    cart.items.forEach(function (it) {
      if (it.properties && Object.prototype.hasOwnProperty.call(it.properties, PROP)) {
        var tag = it.properties[PROP];
        if (tag === o.handle || tag == null) giftIn = true;
        return; /* gift lines never count as buy-products */
      }
      if (giftProductId && it.product_id === giftProductId) {
        giftIn = true;
        return;
      }
      if (it.product_id === o.buy_a.id) hasA = true;
      if (it.product_id === o.buy_b.id) hasB = true;
    });
    return { hasA: hasA, hasB: hasB, giftIn: giftIn, qualifies: hasA && hasB, any: hasA || hasB };
  }

  function selfHeal() {
    if (healCount >= MAX_HEALS) return;
    var now = Date.now();
    if (now - lastHealAt < 4000) return;
    lastHealAt = now;
    healCount++;
    if (healCount >= MAX_HEALS) {
      console.warn('[rastah-gwp] self-heal limit reached - the gift line is not staying in the cart.');
    }
    if (window.rastahGwpSync) window.rastahGwpSync();
  }

  /* v12: document-wide. The cart page section is
     #shopify-section-template--<id>__main, so host-scoped selectors
     never reached it. Only our own gift discount is hidden -- any
     other promotion's label still renders. */
  function sweepDiscountTags() {
    var tags = document.querySelectorAll('[class*="item-discount"]:not(.rastah-gwp-hidden-discount)');
    if (!tags.length) return;
    Array.prototype.forEach.call(tags, function (el) {
      if (el.__gwpChecked) return;
      el.__gwpChecked = true;
      if (el.children && el.querySelector('[class*="item-discount"]')) return; /* container, not a label */
      if ((el.textContent || '').indexOf(GIFT_DISCOUNT_MATCH) === -1) return;
      el.classList.add('rastah-gwp-hidden-discount');
      var box = el.parentElement;
      if (box && /discount/.test(box.className || '')) {
        var visible = box.querySelector('[class*="item-discount"]:not(.rastah-gwp-hidden-discount)');
        if (!visible) box.classList.add('rastah-gwp-hidden-discount');
      }
    });
  }

  function anchorFor(host) {
    return host.querySelector('form') || host.firstElementChild || host;
  }

  function render() {
    if (rendering) return;
    rendering = true;
    sweepDiscountTags();
    var list = offers();
    if (!list.length) { rendering = false; return; }

    getCart().then(function (cart) {
      sweepDiscountTags();
      var needsHeal = false;
      HOSTS.forEach(function (sel) {
        var host = document.querySelector(sel);
        if (!host) return;
        var place = sel.indexOf('quick-cart') > -1 ? 'cart_drawer' : 'cart_page';
        var html = '';

        list.forEach(function (o) {
          if (o.locations && o.locations.length && o.locations.indexOf(place) === -1) return;
          var st = offerState(o, cart);
          if (!st.any) return;
          if (st.qualifies && !st.giftIn) needsHeal = true;
          html += blockHTML(o, st, place);
        });

        var existing = host.querySelectorAll('.' + BLOCK_CLASS);
        var current = '';
        existing.forEach(function (n) { current += n.outerHTML; });
        if (current === html) return; /* unchanged -- avoid loops */

        existing.forEach(function (n) { n.remove(); });
        if (!html) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var anchor = anchorFor(host);
        while (wrap.firstChild) anchor.insertBefore(wrap.firstChild, anchor.firstChild);
      });
      if (needsHeal) selfHeal();
    }).catch(function () {}).then(function () { rendering = false; });
  }

  /* v12: render off the critical path where the browser allows it. */
  function runRender() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(render, { timeout: 600 });
    } else {
      render();
    }
  }

  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runRender, 250);
  }

  /* Add-missing-product clicks (event delegation, survives re-renders) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gwp-add],[data-gwp-add-rel]') : null;
    if (!btn) return;
    e.preventDefault();
    var inCart = !!(btn.closest && btn.closest('#shopify-section-quick-cart, #shopify-section-main-cart'));
    var variantId = 0;
    if (btn.hasAttribute('data-gwp-add')) {
      variantId = parseInt(btn.getAttribute('data-gwp-add'), 10);
    } else {
      var scope = btn.closest('[data-rastah-gwp]') || btn.closest('.rastah-gwp-cartblock__row') || btn.parentElement;
      var sel = scope ? scope.querySelector('select[data-gwp-variant-select]') : null;
      if (sel) variantId = parseInt(sel.value, 10);
    }
    if (!variantId) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).catch(function () {}).then(function () {
      btn.disabled = false;
      var label = btn.querySelector('span') || btn;
      var prev = label.textContent;
      label.textContent = 'Added \u2713';
      setTimeout(function () { label.textContent = prev; }, 1600);
      /* strictly sequential: partner added -> gift reconciled ->
         drawer refreshed -> drawer opened once, fully populated. */
      window.__rastahGwpCart = null;
      var syncP = (window.rastahGwpSync ? window.rastahGwpSync() : null);
      Promise.resolve(syncP).catch(function () {}).then(function () {
        schedule();
        if (!inCart) {
          setTimeout(function () {
            var icon = document.querySelector('[data-js-cart-icon]');
            if (icon) icon.click();
          }, 100);
        }
      });
    });
  });

  /* Re-render whenever the drawer / cart section re-renders */
  function observe() {
    HOSTS.forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host || host.__gwpObserved) return;
      host.__gwpObserved = true;
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    });
  }

  /* React to any cart mutation (fetch + XHR, this theme uses both) */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = _fetch.apply(this, arguments);
    if (CART_RE.test(url)) {
      p.then(function (res) { window.__rastahGwpCart = null; schedule(); observe(); return res; }).catch(function () {});
    }
    return p;
  };

  var XO = XMLHttpRequest.prototype.open;
  var XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__gwpUrl = url || ''; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_RE.test(String(this.__gwpUrl || ''))) {
      this.addEventListener('loadend', function () {
        window.__rastahGwpCart = null;
        if (window.rastahGwpSync) window.rastahGwpSync();
        schedule(); observe();
      });
    }
    return XS.apply(this, arguments);
  };

  /* Quantity steppers / remove links inside cart UIs (belt and braces) */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-gwp-add],[data-gwp-add-rel]')) return; /* ours */
    var t = e.target.closest('#shopify-section-quick-cart button, #shopify-section-main-cart button, #shopify-section-quick-cart a[href*="/cart/change"], #shopify-section-main-cart a[href*="/cart/change"]');
    if (!t) return;
    setTimeout(function () { window.__rastahGwpCart = null; if (window.rastahGwpSync) window.rastahGwpSync(); schedule(); }, 600);
  }, true);

  function boot() {
    injectCSS();
    sweepDiscountTags();
    observe();
    schedule();
    /* keep the cart page's line-item labels clean as it re-renders */
    new MutationObserver(function () { sweepDiscountTags(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
